import clsx from 'clsx';
import React, { FC, ReactNode } from 'react';

export interface TextIconProps {
  text: string;
  icon: ReactNode;
  iconPosition?: 'left' | 'right';
  customClassName?: string;
}

const TextIcon: FC<TextIconProps> = (props: TextIconProps) => {
  const { text, icon, customClassName, iconPosition = 'left' } = props;
  return (
    <p
      className={clsx(
        'flex font-regular font-weight-normal items-center justify-center text-[10px] text-grey60 md:text-[12px]',
        iconPosition === 'right' && 'flex-row-reverse',
        customClassName
      )}
    >
      <span>{icon}</span>
      {text}
    </p>
  );
};

export default TextIcon;
